import { ReactNode } from 'react';
import { Accordion, AccordionProps, Box } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { AccordionTitleContainer, AccordionDetailsContainer } from './styled';
import SText from '../sui/stext';

interface SAccordionProps
  extends Pick<AccordionProps, 'expanded' | 'disabled'> {
  title: string;
  content: ReactNode;
  disableBoxShadow?: boolean;
  onClick: (name?: string) => void;
  rightSection?: JSX.Element;
}

export const SAccordion = ({
  title,
  content,
  disableBoxShadow = true,
  rightSection,
  onClick,
  ...rest
}: SAccordionProps) => (
  <Accordion
    onChange={() => onClick(title)}
    style={{ boxShadow: disableBoxShadow && 'none' }}
    {...rest}>
    <AccordionTitleContainer expandIcon={<ExpandMoreIcon />}>
      <Box
        width="100%"
        display="flex"
        alignItems="center"
        justifyContent="space-between">
        <SText weight="semibold" title={title} />
        {rightSection && rightSection}
      </Box>
    </AccordionTitleContainer>
    <AccordionDetailsContainer>{content}</AccordionDetailsContainer>
  </Accordion>
);
